import React, { useState, useEffect, useRef } from 'react';
import isShowReadMoreText from '@helpers/readMore';
import { cn } from '@helpers/className';

// The lineclamp plugin is only required in Tailwind v2.
// Per the line-clamp plugin, there are 6 default classes.
//
// Plugin: https://github.com/tailwindlabs/tailwindcss-line-clamp
//
// At the time of writing, we don't have any custom configs
// for line-clamp hence why the lines input is limited to 6.
export interface TruncateProps {
  lines: number;
  children?: React.ReactNode;
}

export default function TruncateText({ children, lines }: TruncateProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(true);
  const [isTruncatable, setIsTruncatable] = useState(false);
  useEffect(() => {
    if (containerRef.current) {
      setIsTruncatable(isShowReadMoreText(containerRef, lines));
    }
  }, [setIsTruncatable, lines]);

  const toggleTruncated = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div>
      <div ref={containerRef} className={cn(isTruncatable && isTruncated && `line-clamp-${lines}`)}>
        {children}
      </div>
      {isTruncatable && (
        <button
          className="underline font-rp-pn-semi-bold text-rp-primary-black"
          type="button"
          onClick={toggleTruncated}
        >
          {isTruncated ? 'Read More' : 'Read Less'}
        </button>
      )}
    </div>
  );
}
